import React from 'react';

interface TopAppBarProps {
  title: string;
  branchName?: string;
  showBack?: boolean;
  onBack?: () => void;
  connectionStatus?: 'online' | 'offline' | 'weak';
}

export default function TopAppBar({ 
  title, 
  branchName, 
  showBack = false, 
  onBack,
  connectionStatus = 'online' 
}: TopAppBarProps) {
  return (
    <div className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-40">
      <div className="flex items-center justify-between h-14 px-4">
        <div className="flex items-center gap-3">
          {showBack && (
            <button onClick={onBack} className="w-8 h-8 flex items-center justify-center">
              <i className="ri-arrow-left-line text-xl text-gray-700"></i>
            </button>
          )}
          <div>
            <h1 className="text-base font-bold text-gray-900">{title}</h1>
            {branchName && (
              <span className="text-xs text-gray-500">{branchName}</span>
            )}
          </div>
        </div>
        
        {connectionStatus !== 'online' && (
          <div className="flex items-center gap-1.5 px-2 py-1 bg-amber-50 rounded-full">
            <i className="ri-wifi-off-line text-xs text-amber-600"></i>
            <span className="text-xs text-amber-700 font-medium">
              {connectionStatus === 'offline' ? 'Offline' : 'Svag signal'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
